import React from 'react'
import { Loader } from '@web/walter-ui-kit'

import styles from './styles.module.css'

function Card() {
    return (
        <div className={styles.card}>
            <div className={styles.title}>
                <Loader width={72} height={20} />
                <Loader width={60} height={20} />
            </div>
            <div className={styles.dividerCard} />
            <div className={styles.description}>
                <Loader width={200} height={20} />
            </div>
            <div className={styles.body}>
                <div className={styles.row}>
                    <Loader width={32} height={32} isCircled />
                    <Loader width={100} height={20} />
                </div>
                <div className={styles.row}>
                    <Loader width={32} height={32} isCircled />
                    <Loader width={100} height={20} />
                </div>
                <div className={styles.row}>
                    <Loader width={32} height={32} isCircled />
                    <Loader width={100} height={20} />
                </div>
            </div>
        </div>
    )
}

function Preloader() {
    return (
        <div className={styles.cards}>
            <Card />
            <div className={styles.divider} />
            <Card />
            <div className={styles.divider} />
            <Card />
        </div>
    )
}

export default Preloader
